import { unreachable } from 'utils/unreachable';
import { Just, Nothing } from './maybe';
export const ok = (value)=>[
        'ok',
        value
    ];
export const error = (err)=>[
        'error',
        err
    ];
export const value = (result)=>result[0] === 'ok' ? Just(result[1]) : Nothing();
export const map = (mapper)=>(result)=>result[0] === 'error' ? result : ok(mapper(result[1]));
export const flatten = (deep)=>deep[0] === 'error' ? deep : deep[1];
export const flatMap = (mapper)=>(result)=>flatten(map(mapper)(result));
const _on = (onOk, onError)=>(result)=>{
        switch(result[0]){
            case 'ok':
                return onOk(result[1]);
            case 'error':
                return onError === null || onError === void 0 ? void 0 : onError(result[1]);
            default:
                return unreachable(result);
        }
    };
export const on = (onOk, onError)=>(result)=>{
        _on(onOk, onError)(result);
        return result;
    };
export const Result = {
    ok,
    error,
    value,
    map,
    flatten,
    flatMap,
    on
};
